import React from 'react'
import Lottie from 'react-lottie-player'

const Lottieplayer = ({lottieUrl,Lottiestyle,speed,backgroundColor}) => {
  return (
    <Lottie
                 loop
               // src="../images/star-icon.json"
                animationData={lottieUrl||''}
                background={backgroundColor ||"transparent"}
                speed={speed ||"1"}
                play
                style={Lottiestyle}
                autoPlay>
       </Lottie>
  )
}

export default Lottieplayer
